import React from 'react';
import { useI18n } from '../../context/I18nContext';

export const LanguageToggle = () => {
  const { language, changeLanguage } = useI18n();

  return (
    <div className="flex items-center space-x-2">
      <button
        onClick={() => changeLanguage('it')}
        className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${
          language === 'it'
            ? 'bg-blue-600 text-white'
            : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
        }`}
        title="Italiano"
      >
        IT
      </button>
      <button
        onClick={() => changeLanguage('en')}
        className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${
          language === 'en'
            ? 'bg-blue-600 text-white'
            : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
        }`}
        title="English"
      >
        EN
      </button>
    </div>
  );
};

